import Layout from "../components/Layout";
import useSocket from "../hooks/useSocket";
import { MdCircle } from "react-icons/md";

const Monitoring = () => {
  const { monitoringData, connected } = useSocket();

  return (
    <Layout>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Real-time Monitoring
          </h2>
          <p className="text-sm text-gray-500">
            Updates every 30 seconds
          </p>
        </div>

        {/* Connection Status */}
        <div className="flex items-center gap-2 text-sm">
          <MdCircle
            size={12}
            className={connected ? "text-green-500" : "text-red-500"}
          />
          <span className={connected ? "text-green-600" : "text-red-600"}>
            {connected ? "Live" : "Disconnected"}
          </span>
        </div>
      </div>

      {/* Device Table */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
            <tr>
              <th className="px-6 py-3 text-left">Device</th>
              <th className="px-6 py-3 text-left">IP Address</th>
              <th className="px-6 py-3 text-left">Status</th>
              <th className="px-6 py-3 text-left">Latency</th>
              <th className="px-6 py-3 text-left">Bandwidth In</th>
              <th className="px-6 py-3 text-left">Bandwidth Out</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {monitoringData.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-6 py-8 text-center text-gray-400">
                  Waiting for monitoring data...
                </td>
              </tr>
            ) : (
              monitoringData.map((device) => (
                <tr key={device.deviceId} className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-800">
                    {device.name}
                  </td>
                  <td className="px-6 py-4 text-gray-600">
                    {device.ipAddress}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        device.status === "ONLINE"
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {device.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-600">
                    {device.latency ? `${device.latency}ms` : "N/A"}
                  </td>
                  <td className="px-6 py-4 text-gray-600">
                    {device.inOctets
                      ? `${(device.inOctets / 1024).toFixed(2)} KB`
                      : "N/A"}
                  </td>
                  <td className="px-6 py-4 text-gray-600">
                    {device.outOctets
                      ? `${(device.outOctets / 1024).toFixed(2)} KB`
                      : "N/A"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </Layout>
  );
};

export default Monitoring;